// GENERATED CODE - DO NOT EDIT
export const PrescriptionStatusMap = {
    RECEIVED_BY_ALTO: 'received_by_alto',
    PHARMACIST_REVIEW: 'pharmacist_review',
    SEARCHING_FOR_SAVINGS: 'searching_for_savings',
    READY: 'ready',
    MULTIPLE_PRICES: 'multiple_prices',
    PRIOR_AUTH_IN_PROGRESS: 'prior_auth_in_progress',
    BACKORDERED: 'backordered',
    OBSOLETED: 'obsoleted',
    PROGYNY_EARLY_ORDER_ELIGIBLE: 'progyny_early_order_eligible',
    PROGYNY_EARLY_ORDER_REQUESTED: 'progyny_early_order_requested',
    PROGYNY_EXPIRED_COVERAGE: 'progyny_expired_coverage',
};
//# sourceMappingURL=prescription_status.js.map